import * as React from "react";
import { ProductDetailDrawer } from "../../../../../ProductDetailDrawer/modules/ProductDetailDrawer/ProductDetailDrawer.js";
import { ProductDetailReviewsCTA } from "../../../components/ProductDetailReviewsCTA/modules/PrimaryProductInfo/ProductDetailReviews/components/ProductDetailReviewsCTA/ProductDetailReviewsCTA.js";
const ProductDetailReviews = ({ title, children }) => /* @__PURE__ */ React.createElement(
  ProductDetailDrawer,
  {
    title,
    "data-t": "reviews-drawer",
    ctaButton: /* @__PURE__ */ React.createElement(ProductDetailReviewsCTA, { title }),
    shouldMountContent: true
  },
  /* @__PURE__ */ React.createElement("div", { className: "product-detail-reviews__content" }, children)
);
export {
  ProductDetailReviews
};
//# sourceMappingURL=ProductDetailReviews.js.map
